import {getCookie, setCookie} from "@insite/client-framework/Common/Cookies";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import FirstLoginWelcomeModal from "@preferredMedical/Widgets/Header/FirstLoginWelcomeModal"
import React from "react";

const enum fields {
    title = "title",
    description = "description",
    resetPasswordLabel = "resetPasswordLabel"
}

type Props = WidgetProps;

const firstLoginWelcomeCookieName = "ShowFirstLoginWelcomeModal"

const FirstLoginWelcomeWidget: React.FC<Props> = ({ fields }) => {
    const firstLoginWelcomeCookie = getCookie(firstLoginWelcomeCookieName);

    if(firstLoginWelcomeCookie)
        {return null;}
        
    setCookie(firstLoginWelcomeCookieName, "false", {expires: 365});

    return (
        <FirstLoginWelcomeModal
                title={fields.title}
                description={fields.description}
                resetPasswordLabel={fields.resetPasswordLabel}
        />
    );
};

const widgetModule: WidgetModule = {
    component: FirstLoginWelcomeWidget,
    definition: {
        displayName: "First Login Welcome",
        group: "Header",
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Modal Title",
                editorTemplate: "MultilineTextField",
                fieldType: "General",
                defaultValue: "Good Things Happen",
                isRequired: true,
            },
            {
                name: fields.description,
                displayName: "Modal Description",
                editorTemplate: "MultilineTextField",
                fieldType: "General",
                defaultValue: "Wolf Medical Supply, An NDC Company, is committed to being your trusted partner" +
                 " in healthcare. We are excited to announce that we have launched a new and improved website" +
                 " for Wolf Medical customers. You will not need to create a new account, but for security purposes" +
                 " you will need to reset your password before you can login to the new site for the first time.",
                isRequired: true,
            },
            {
                name: fields.resetPasswordLabel,
                displayName: "Reset Password Label",
                editorTemplate: "MultilineTextField",
                fieldType: "General",
                defaultValue: "Click here to reset your password now.",
                isRequired: true,
            }
        ]
    },
};

export default widgetModule;